import React from 'react';
import { styled } from "styled-components";

const Item = styled.button`
  display: flex;
  
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  background: #F8F1FF;
  color: #9738FF;
  border: 0px;
  margin: 5px 10px 5px 0px;

  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  &:hover {
    background: #9738FF;
    color: #FFF;
  }
`;

const Tag = ({title, icon, cb}) => {
  return (
    <Item onClick={cb}>
      {icon} {title}
    </Item>
  );
};

export default Tag;
